<template>
  <div class='indexbox'>
    <nav-bar left-arrow :title="$t('公告详情')" />
    <div class="bodybox">
      <!-- <p class="tit">{{ info.title }}</p> -->
      <p class="tit" v-if="getLang() == 'zh'">{{ info.title }}</p>
      <p class="tit" v-if="getLang() == 'en'">{{ info.title_en }}</p>
      <p class="tit" v-if="getLang() == 'tw'">{{ info.title_tw }}</p>

      <p class="time">{{ info.updated_at }}</p>
      <!-- <div class="msgbox htmlcontentbox" v-html="info.content"></div> -->

      <div v-if="getLang() == 'zh'" class="msgbox htmlcontentbox" v-html="info.content"></div>
      <div v-if="getLang() == 'en'" class="msgbox htmlcontentbox" v-html="info.content_en"></div>
      <div v-if="getLang() == 'tw'" class="msgbox htmlcontentbox" v-html="info.content_tw"></div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: {},
    }
  },
  created() {
    this.getdata()
  },
  methods: {
    getdata() {
      this.$get({
        loading: true,
        url: `/api/v1/notice/info?id=${this.urlQuery().id}`,
        success: (res) => {
          this.info = res.data
        },
        tip: () => { },
      })
    },
  },
}
</script>
<style lang='less' scoped>
.indexbox {
  width: 100%;
  padding: 15px 15px 40px;

  .bodybox {
    width: 100%;
    // background: #242424;
    border-radius: 6px 6px 6px 6px;
    padding: 20px 10px;

    .tit {
      width: 100%;
      font-size: 18px;
      font-weight: 550;
    }

    .time {
      width: 100%;
      padding: 10px 0;
      color: #999999;
      font-size: 13px;
    }

    .msgbox {
      width: 100%;
      color: #999999;
      font-size: 14px;
    }
  }
}
</style>